import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { handleResponseThrowError } from '@/_utils/services';
import { DEFAULT_LIMIT_REQUEST } from '@/Constants';
import { apiClientOld } from '@/_config/lib/axios/api-client-old';
import { GET_TICKETS } from './constants';
import type { Ticket } from '../types';

type GetTicketsParams = {
  limit?: number;
  page?: number;
  placeId: string;
};

const getTickets = (params: GetTicketsParams) => {
  const { page, limit, placeId } = params;

  const newPage = page || 1;
  const newLimit = limit || DEFAULT_LIMIT_REQUEST;
  const offset = (newPage - 1) * newLimit;

  return apiClientOld
    .get<Ticket[]>(`/estabelecimentos/${placeId}/bank/boletos`, {
      params: {
        limit,
        offset,
      },
    })
    .then(response => response.data)
    .catch(handleResponseThrowError());
};

type GetTicketsResponse = Awaited<ReturnType<typeof getTickets>>;

export const useGetTickets = (
  params: GetTicketsParams,
  options: Omit<
    UseQueryOptions<
      GetTicketsResponse,
      unknown,
      GetTicketsResponse,
      (string | GetTicketsParams)[]
    >,
    'queryKey' | 'queryFn'
  > = {},
) => {
  return useQuery({
    queryKey: [GET_TICKETS, params],
    queryFn: () => getTickets(params),
    ...options,
  });
};
